/* eslint-disable simple-import-sort/imports */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "../../../utils/api-client";
import {
	RegularShiftRequest,
	WorkerRequestsStateTypes,
} from "./worker-requests-types";

import {
	setSupervisorRateLimitError,
  } from "../../user/user-slice";
import{
	ftRequestSwapProps,
	updateSwapRequestsTypes,
} from "./worker-requests-types";
import {
	FLEX_SHIFT_REQUEST_FILTERS,
	TIME_OFF_REQUEST_FILTERS,
	WORKER_REQUEST_FILTERS,
} from "../../../assets/constants";

const initialState: WorkerRequestsStateTypes = {
	allRegularRequests: [],
	allShiftSwapRequests: [],
	fullTimeRequestStatuses: [],
	flexRequestStatuses: [],
	getAllRegularRequests: {
		status: "idle",
		errorMessage: "",
	},
	getAllRequestStatuses: {
		status: "idle",
		errorMessage: "",
	},
	requestShiftAction: {
		status: "idle",
		errorMessage: "",
	},
	shiftFormData: {},
	workerRequestMetaData: {},
	updateSwapRequests: {
		status: "idle",
		errorMessage: "",
	},
	shiftSwapRequests: {
		status: "idle",
		errorMessage: "",
	},
	getShiftMetaData: {
		status: "idle",
		errorMessage: "",
		data: {},
	},
	leaveCalendarCounts: {
		status: "idle",
		errorMessage: "",
		data: [],
	},
	leaveCalendarDetails: {
		status: "idle",
		errorMessage: "",
		data: [],
	},
	leaveCalendarTimeline: {
		status: "idle",
		errorMessage: "",
		data: {
			leaves: [],
			workers: [],
		},
	},
	getFiltersForUser: {
		status: "idle",
		errorMessage: "",
		data: {},
	},
	timeOffRequestFilters: {
		status: "idle",
		errorMessage: "",
		data: {},
	},
	flexShiftRequestFilters: {
		status: "idle",
		errorMessage: "",
		data: {},
	},
};

// getAllRegularRequests
export const getAllRegularRequests = createAsyncThunk(
	"worker-requests/get-all-regular-requests",
	async ({startDate=null, endDate=null} : ftRequestSwapProps, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const queryParams = new URLSearchParams();
			if (startDate) queryParams.append("startDate", startDate);
			if (endDate) queryParams.append("endDate", endDate);
			
			const res = await axios.get(
				`${process.env.REACT_APP_API_END_POINT}/workers/requestsForUser?${queryParams.toString()}`
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if(errorResponse.status === 429){
					dispatch(setSupervisorRateLimitError())
					return rejectWithValue(errorResponse)
				}
				return rejectWithValue(error.response.data.message);
			} catch (e) {
				return rejectWithValue("An error occurred");
			}
		}
	}
);

// API to get all regular requests
export const getAllRequestsTypes = createAsyncThunk(
	"worker-requests/get-all-requests-types",
	async (payload, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const res = await axios.get(
				`${process.env.REACT_APP_API_END_POINT}/workers/requestStatuses`
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if(errorResponse.status === 429){
					dispatch(setSupervisorRateLimitError())
					return rejectWithValue(errorResponse)
				}
				return rejectWithValue(error.response.data.message);
			} catch (e) {
				return rejectWithValue("An error occurred");
			}
		}
	}
);

// API to perform action on a request
export const requestShiftAction = createAsyncThunk(
	"gat-admin/request-shift-action",
	async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const res = await axios.post(
				`${process.env.REACT_APP_API_END_POINT}/workers/requestAction`,
				payload
			);
			if (res.status === 200 || res.status === 201) {
				return fulfillWithValue(payload);
			}
			return rejectWithValue("An error occurred");
		} catch (error: any) {
			const { setSubmitting } = payload;
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			if (setSubmitting) {
				setSubmitting(false);
			}
			try {
				if(errorResponse.status === 429){
					dispatch(setSupervisorRateLimitError())
					return rejectWithValue(errorResponse)
				}
				return rejectWithValue(error.response.data.message);
			} catch (e) {
				return rejectWithValue("An error occurred");
			}
		}
	}
);

// API to get all swap requests
export const fetchAllSwapRequests = createAsyncThunk(
	"scheduler/fetchAllSwapRequests",
	async (payload: { startDate?: string; endDate?: string } | undefined, thunkAPI) => {
		try {
			let url = `${process.env.REACT_APP_API_END_POINT}/ShiftSwap/GetAllForUser`;
			
			if (payload?.endDate) {
				url += `?endDate=${payload.endDate}`;
				if (payload.startDate) {
					url += `&startDate=${payload.startDate}`;
				}
			}

			const response = await axios.get(url);

			if (response?.status === 200) {
				return thunkAPI.fulfillWithValue(response.data);
			}
			return thunkAPI.rejectWithValue([]);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if(errorResponse.status === 429){
					thunkAPI.dispatch(setSupervisorRateLimitError())
					return thunkAPI.rejectWithValue(errorResponse)
				}
				return thunkAPI.rejectWithValue(error.response.data.message);
			} catch (e) {
				return thunkAPI.rejectWithValue("An error occurred");
			}
		}
	}
);
// API to update swap requests
export const updateSwapRequests = createAsyncThunk(
	"scheduler/updateSwapRequests",
	async (payload: updateSwapRequestsTypes, thunkAPI) => {
		// console.log("payload", payload);
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_END_POINT}/ShiftSwap/Approve`,
				payload
			);
			// console.log("--res---", response);
			if (response.status === 200) {
				return thunkAPI.fulfillWithValue(payload);
			}
			return thunkAPI.fulfillWithValue(payload);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if(errorResponse.status === 429){
					thunkAPI.dispatch(setSupervisorRateLimitError())
					return thunkAPI.rejectWithValue(errorResponse)
				}
				return thunkAPI.rejectWithValue(error.response.data.message);
			} catch (e) {
				return thunkAPI.rejectWithValue("An error occurred");
			}
		}
	}
);

// Api to get shift meta data
export const getShiftMetaData = createAsyncThunk(
	"scheduler/get-shift-meta-data",
	async (payload: number, thunkAPI) => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_END_POINT}/Shifts/SignUpTracking?id=${payload}`
			);
			if (response?.status === 200) {
				return thunkAPI.fulfillWithValue(response.data);
			}
			return thunkAPI.rejectWithValue({});
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if(errorResponse.status === 429){
					thunkAPI.dispatch(setSupervisorRateLimitError())
					return thunkAPI.rejectWithValue(errorResponse)
				}
				return thunkAPI.rejectWithValue(error.response.data.message);
			} catch (e) {
				return thunkAPI.rejectWithValue("An error occurred");
			}
		}
	}
);

export const fetchLeaveCalendarCounts = createAsyncThunk(
	"worker-requests/fetch-leave-calendar-counts",
	async ({ startDate, endDate }: { startDate: string; endDate: string }, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const res = await axios.get(
				`${process.env.REACT_APP_API_END_POINT}/leave-calendar/counts?startDate=${startDate}&endDate=${endDate}`
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			if (error?.response?.status === 429) {
				dispatch(setSupervisorRateLimitError());
				return rejectWithValue(errorResponse);
			}
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

export const fetchLeaveCalendarDetails = createAsyncThunk(
	"worker-requests/fetch-leave-calendar-details",
	async (date: string, { fulfillWithValue, rejectWithValue, dispatch, signal }) => {
		try {
			const res = await axios.get(
				`${process.env.REACT_APP_API_END_POINT}/leave-calendar/details?date=${date}`,
				{ signal }
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			if (axios.isCancel(error)) {
				return rejectWithValue("Canceled");
			}
			const errorResponse = error?.response?.data;
			if (error?.response?.status === 429) {
				dispatch(setSupervisorRateLimitError());
				return rejectWithValue(errorResponse);
			}
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

export const fetchFiltersForUser = createAsyncThunk(
	"worker-requests/fetch-filters-for-user",
	async (_, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const res = await axios.post(
        `${process.env.REACT_APP_API_END_POINT}/FlexScheduler/GetFiltersForUser`,
        {
          filters: WORKER_REQUEST_FILTERS,
        }
      );
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if (errorResponse.status === 429) {
					dispatch(setSupervisorRateLimitError());
					return rejectWithValue(errorResponse);
				}
				return rejectWithValue(error.response.data.message);
			} catch (e) {
				return rejectWithValue("An error occurred");
			}
		}
	}
);

// Page-specific filter options (per-page filter constants convention): the
// Time Off Requests page (Requests table + Calendar tab).
export const fetchTimeOffRequestFilters = createAsyncThunk(
	"worker-requests/fetch-time-off-request-filters",
	async (_, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const res = await axios.post(
				`${process.env.REACT_APP_API_END_POINT}/FlexScheduler/GetFiltersForUser`,
				{
					filters: TIME_OFF_REQUEST_FILTERS,
				}
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if (errorResponse.status === 429) {
					dispatch(setSupervisorRateLimitError());
					return rejectWithValue(errorResponse);
				}
				return rejectWithValue(error.response.data.message);
			} catch (e) {
				return rejectWithValue("An error occurred");
			}
		}
	}
);

// Page-specific filter options: the Flex Shift Requests page.
export const fetchFlexShiftRequestFilters = createAsyncThunk(
	"worker-requests/fetch-flex-shift-request-filters",
	async (_, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			const res = await axios.post(
				`${process.env.REACT_APP_API_END_POINT}/FlexScheduler/GetFiltersForUser`,
				{
					filters: FLEX_SHIFT_REQUEST_FILTERS,
				}
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			errorResponse.status = error?.response?.status;
			try {
				if (errorResponse.status === 429) {
					dispatch(setSupervisorRateLimitError());
					return rejectWithValue(errorResponse);
				}
				return rejectWithValue(error.response.data.message);
			} catch (e) {
				return rejectWithValue("An error occurred");
			}
		}
	}
);

export const fetchLeaveCalendarTimeline = createAsyncThunk(
	"worker-requests/fetch-leave-calendar-timeline",
	async (
		{ startDate, endDate, shiftPatternId, workcenterId }: {
			startDate: string;
			endDate: string;
			shiftPatternId?: number | null;
			workcenterId?: number | null;
		},
		{ fulfillWithValue, rejectWithValue, dispatch }
	) => {
		try {
			const params = new URLSearchParams({ startDate, endDate });
			if (shiftPatternId) params.append("shiftPatternId", shiftPatternId.toString());
			if (workcenterId) params.append("workcenterId", workcenterId.toString());
			const res = await axios.get(
				`${process.env.REACT_APP_API_END_POINT}/leave-calendar/timeline?${params.toString()}`
			);
			return fulfillWithValue(res.data);
		} catch (error: any) {
			const errorResponse = error?.response?.data;
			if (error?.response?.status === 429) {
				dispatch(setSupervisorRateLimitError());
				return rejectWithValue(errorResponse);
			}
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

export const WorkerRequestsSlice = createSlice({
	name: "workerRequests",
	initialState,
	reducers: {
		resetGetAllWorkerRequestsAsyncState: (state) => {
			state.getAllRegularRequests = {
				status: "idle",
				errorMessage: "",
			};
		},
		resetShiftActions: (state) => {
			state.requestShiftAction = {
				status: "idle",
				errorMessage: "",
			};
		},
		resetShiftFormData: (state) => {
			state.shiftFormData = {};
		},
		setShiftFormData: (state, action) => {
			state.shiftFormData = action.payload;
		},
		setWorkerRequestMetaData: (state, action) => {
			state.workerRequestMetaData = action.payload;
		},
		resetWorkerRequestMetaData: (state) => {
			state.workerRequestMetaData = {};
		},
		resetUpdateRequestsStatus: (state) => {
			state.updateSwapRequests.status = "idle";
			state.updateSwapRequests.errorMessage = "";
		},
		setRequestData: (state, action) => {
			state.shiftFormData = action.payload;
		},
	},
	extraReducers: (builder) => {
		// getAllRegularRequests
		builder.addCase(
			getAllRegularRequests.pending,
			(state: WorkerRequestsStateTypes) => {
				state.getAllRegularRequests.status = "pending";
			}
		);
		builder.addCase(
			getAllRegularRequests.rejected,
			(state: WorkerRequestsStateTypes, action) => {
				if ((action.payload as { status?: number })?.status === 429) {
					state.getAllRegularRequests.status = "error";
				} else {
					state.getAllRegularRequests.status = "error";
					state.getAllRegularRequests.errorMessage =
						action.payload ?? "An error occurred";
				}
			}
		);
		builder.addCase(getAllRegularRequests.fulfilled, (state, action) => {
			const temp = action.payload.map(
				(it: RegularShiftRequest, idx: number) => ({
					...it,
					id: it.workerId + idx,
				})
			);
			// const filterRegularRequests = temp.filter(
			// 	(it: RegularShiftRequest) => it.requestType["code"] !== "lr"
			// );
			state.allRegularRequests = temp;
			state.getAllRegularRequests.status = "fulfilled";
		});
		// requestShiftAction
		builder.addCase(
			requestShiftAction.pending,
			(state: WorkerRequestsStateTypes) => {
				state.requestShiftAction.status = "pending";
			}
		);
		builder.addCase(
			requestShiftAction.rejected,
			(state: WorkerRequestsStateTypes, action) => {
				if((action.payload as { status?: number })?.status === 429){
					state.requestShiftAction.status = "error";
				}
				else{
					state.requestShiftAction.status = "error";
					state.requestShiftAction.errorMessage =
						action.payload ?? "An error occurred";
				}
			}
		);
		builder.addCase(requestShiftAction.fulfilled, (state, action) => {
			state.requestShiftAction.status = "fulfilled";
		});
		// getAllRequestsTypes
		builder.addCase(
			getAllRequestsTypes.pending,
			(state: WorkerRequestsStateTypes) => {
				state.getAllRequestStatuses.status = "pending";
			}
		);
		builder.addCase(
			getAllRequestsTypes.rejected,
			(state: WorkerRequestsStateTypes, action) => {
				if((action.payload as { status?: number })?.status === 429){
					state.getAllRequestStatuses.status = "error";
				}
				else{
					state.getAllRequestStatuses.status = "error";
					state.getAllRequestStatuses.errorMessage =
						action.payload ?? "An error occurred";
				}
			}
		);
		builder.addCase(getAllRequestsTypes.fulfilled, (state, action) => {
			state.fullTimeRequestStatuses = action.payload["fullTime"];
			state.flexRequestStatuses = action.payload["flex"];
			state.getAllRequestStatuses.status = "fulfilled";
		});

		// updateSwapRequests
		builder.addCase(updateSwapRequests.fulfilled, (state: any, action) => {
			state.updateSwapRequests.status = "fulfilled";
			//state.shiftSwapRequests.data =
			const id = action.payload.Id;
			const updatedShiftSwapRequests = state.allShiftSwapRequests.map(
				(item: any) => {
					if (item.id === id) {
						return {
							...item,
							approvalStatus: action.payload.status,
						};
					}
					return item;
				}
			);

			state.allShiftSwapRequests = updatedShiftSwapRequests;
		});
		builder.addCase(updateSwapRequests.pending, (state) => {
			state.updateSwapRequests.status = "pending";
		});
		builder.addCase(updateSwapRequests.rejected, (state: any, action) => {
			if((action.payload as { status?: number })?.status === 429){
				state.updateSwapRequests.status = "error";
			}
			else{
				state.updateSwapRequests.status = "error";
				state.updateSwapRequests.errorMessage =
					action.payload ?? "An error occurred";
			}
		});

		// shift swap requests

		builder.addCase(fetchAllSwapRequests.fulfilled, (state, action) => {
			state.shiftSwapRequests.status = "fulfilled";
			state.allShiftSwapRequests = action.payload;
		});
		builder.addCase(fetchAllSwapRequests.pending, (state) => {
			state.shiftSwapRequests.status = "pending";
		});
		builder.addCase(fetchAllSwapRequests.rejected, (state, action) => {
			if((action.payload as { status?: number })?.status === 429){
				state.shiftSwapRequests.status = "error";
			}
			else{
				state.shiftSwapRequests.status = "error";
				state.shiftSwapRequests.errorMessage =
					action.payload ?? "An error occurred";
			}
		});

		// getShiftMetaData
		builder.addCase(
			getShiftMetaData.pending,
			(state: WorkerRequestsStateTypes) => {
				state.getShiftMetaData.status = "pending";
			}
		);
		builder.addCase(
			getShiftMetaData.rejected,
			(state: WorkerRequestsStateTypes, action) => {
				if((action.payload as { status?: number })?.status === 429){
					state.getShiftMetaData.status = "error";
				}
				else{
				state.getShiftMetaData.status = "error";
				state.getShiftMetaData.errorMessage =
					action.payload ?? "An error occurred";
				}
			}
		);
		builder.addCase(getShiftMetaData.fulfilled, (state, action) => {
			state.getShiftMetaData.status = "fulfilled";
			state.getShiftMetaData.data = action.payload;
		});

		// fetchLeaveCalendarCounts
		builder.addCase(fetchLeaveCalendarCounts.pending, (state) => {
			state.leaveCalendarCounts.status = "pending";
		});
		builder.addCase(fetchLeaveCalendarCounts.fulfilled, (state, action) => {
			state.leaveCalendarCounts.status = "fulfilled";
			state.leaveCalendarCounts.data = action.payload;
		});
		builder.addCase(fetchLeaveCalendarCounts.rejected, (state, action) => {
			state.leaveCalendarCounts.status = "error";
			state.leaveCalendarCounts.errorMessage = action.payload ?? "An error occurred";
		});

		// fetchLeaveCalendarDetails
		builder.addCase(fetchLeaveCalendarDetails.pending, (state) => {
			state.leaveCalendarDetails.status = "pending";
			state.leaveCalendarDetails.data = [];
		});
		builder.addCase(fetchLeaveCalendarDetails.fulfilled, (state, action) => {
			state.leaveCalendarDetails.status = "fulfilled";
			state.leaveCalendarDetails.data = action.payload;
		});
		builder.addCase(fetchLeaveCalendarDetails.rejected, (state, action) => {
			if (action.meta.aborted) {
				return;
			}
			state.leaveCalendarDetails.status = "error";
			state.leaveCalendarDetails.errorMessage = action.payload ?? "An error occurred";
		});

		// fetchLeaveCalendarTimeline
		builder.addCase(fetchLeaveCalendarTimeline.pending, (state) => {
			state.leaveCalendarTimeline.status = "pending";
		});
		builder.addCase(fetchLeaveCalendarTimeline.fulfilled, (state, action) => {
			state.leaveCalendarTimeline.status = "fulfilled";
			state.leaveCalendarTimeline.data = action.payload;
		});
		builder.addCase(fetchLeaveCalendarTimeline.rejected, (state, action) => {
			state.leaveCalendarTimeline.status = "error";
			state.leaveCalendarTimeline.errorMessage = action.payload ?? "An error occurred";
		});

		// fetchFiltersForUser
		builder.addCase(fetchFiltersForUser.pending, (state) => {
			state.getFiltersForUser.status = "pending";
		});
		builder.addCase(fetchFiltersForUser.fulfilled, (state, action) => {
			state.getFiltersForUser.status = "fulfilled";
			state.getFiltersForUser.data = action.payload;
		});
		builder.addCase(fetchFiltersForUser.rejected, (state, action) => {
			state.getFiltersForUser.status = "error";
			state.getFiltersForUser.errorMessage = action.payload ?? "An error occurred";
		});

		// fetchTimeOffRequestFilters
		builder.addCase(fetchTimeOffRequestFilters.pending, (state) => {
			state.timeOffRequestFilters.status = "pending";
		});
		builder.addCase(fetchTimeOffRequestFilters.fulfilled, (state, action) => {
			state.timeOffRequestFilters.status = "fulfilled";
			state.timeOffRequestFilters.data = action.payload;
		});
		builder.addCase(fetchTimeOffRequestFilters.rejected, (state, action) => {
			state.timeOffRequestFilters.status = "error";
			state.timeOffRequestFilters.errorMessage =
				action.payload ?? "An error occurred";
		});

		// fetchFlexShiftRequestFilters
		builder.addCase(fetchFlexShiftRequestFilters.pending, (state) => {
			state.flexShiftRequestFilters.status = "pending";
		});
		builder.addCase(fetchFlexShiftRequestFilters.fulfilled, (state, action) => {
			state.flexShiftRequestFilters.status = "fulfilled";
			state.flexShiftRequestFilters.data = action.payload;
		});
		builder.addCase(fetchFlexShiftRequestFilters.rejected, (state, action) => {
			state.flexShiftRequestFilters.status = "error";
			state.flexShiftRequestFilters.errorMessage =
				action.payload ?? "An error occurred";
		});
	},
});

export const {
	resetGetAllWorkerRequestsAsyncState,
	resetShiftFormData,
	setShiftFormData,
	resetShiftActions,
	resetUpdateRequestsStatus,
	setWorkerRequestMetaData,
	resetWorkerRequestMetaData,
} = WorkerRequestsSlice.actions;

export default WorkerRequestsSlice.reducer;
